import { useHasCapability } from '@apis/capability/use-has-capability/use-has-capability';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

import { TelemetryCapabilities } from '../../../telemetry.constants';

export const useHasUpgradeSSCAccess = () => {
  const [rbacByPassFF] = useFeatureFlag('SSC_SELF_SERVICE_UPGRADE_RBAC_BYPASS');
  const [sscUpgradeFF] = useFeatureFlag('SSC_SELF_SERVICE_UPGRADE');
  const { hasCapability } = useHasCapability(
    TelemetryCapabilities.SscManageApplianceWrite,
  );

  if (rbacByPassFF) {
    return true;
  }

  return sscUpgradeFF && hasCapability;
};
